/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* YouTube facade: load player only on click */
(function () {
  function init() {
    var facades = document.querySelectorAll('.yt-facade[data-yt]');
    if (!facades.length) return;
    facades.forEach(function (el) {
      if (el.dataset.ytReady) return;
      el.dataset.ytReady = '1';
      var id = (el.getAttribute('data-yt') || '').trim();
      if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;

      var img = document.createElement('img');
      img.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
      img.alt = el.getAttribute('data-title') || 'Play video';
      img.loading = 'lazy';
      img.className = 'yt-facade__thumb';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'yt-facade__play';
      btn.setAttribute('aria-label', 'Play video');
      btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';

      el.appendChild(img);
      el.appendChild(btn);

      el.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.className = 'yt-facade__frame';
        f.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1';
        f.title = el.getAttribute('data-title') || 'YouTube video';
        f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        f.allowFullscreen = true;
        el.innerHTML = '';
        el.appendChild(f);
      }, { once: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();